<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h4><font-awesome-icon icon="plus-square" /> Add State</h4>
      <form name="form" @submit.prevent="saveState">
        <div v-if="!successful">
          <div class="form-group">
            <label for="code">Code:</label>
            <input v-model="state.code" v-validate="'required|min:2|max:6'" type="text" class="form-control" id="code" name="code"/>
            <div v-if="submitted && errors.has('code')" class="alert-danger">{{errors.first('code')}}</div>
          </div>
          <div class="form-group">
            <label for="name">Name:</label>
            <input v-model="state.name" v-validate="'required|min:3|max:75'" type="text" class="form-control" id="name" name="name"/>
            <div v-if="submitted && errors.has('name')" class="alert-danger" >{{errors.first('name')}}</div>
          </div>
          <div class="form-group">
            <label for="countries">Select Country:</label>
            <select @change="onChangeCountry($event)" v-validate="'required'" class="form-control" id="countryId" name="countryId">
              <option v-for="(country, index) in countries" :value="index" :key="index">{{ country.name }}</option>
            </select>
            <div v-if="submitted && errors.has('countries')" class="alert-danger">{{errors.first('countries')}}</div>
          </div>
          <div class="form-group">
            <button type="submit" class="m-3 btn btn-sm btn-success"><font-awesome-icon icon="save" /> Save</button>
            <button class="m-3 btn btn-sm btn-primary" @click="statesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="newState"><font-awesome-icon icon="plus" /> Add State</button>
      </div>
    </div>
  </div>
</template>

<script>
import StateService from "../services/state.service";
import CountryService from "../services/country.service";

export default {
  name: 'add-state',
  data() {
    return {
      state: {
        id: null,
        code: '',
        name: '',
        countryId: null
      },
      submitted: false,
      successful: false,
      message: '',
      countries: [],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    retrieveCountries() {
      CountryService.getAll()
        .then(response => {
          this.countries = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeCountry: function(e) {
      this.state.countryId = e.target.value;
    },

    saveState() {
      console.log('countryId: '+this.state.countryId);
      var stateData = {
        code: this.state.code,
        name: this.state.name,
        countryId: this.state.countryId
      };
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          StateService.create(stateData).then(
            response => {
              this.message = 'The state was created successfully!';
              this.state.id = response.data.id;
              //console.log('data: '+response.data);
              this.submitted = true;
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log('e: '+e);
              this.message = e.message;
              console.log('e message: '+e.message);
            });
        }
      });
    },

    newState() {
      this.submitted = false;
      this.successful = false;
      this.message = '';
      this.state = {};
      //this.countries = [];
    },
    
    statesList() {
      this.$router.push('/states');
    }
  },

  mounted() {
    this.retrieveCountries();
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>